const a = {
  id: "NebraskaMyDay",
  name: "MyDaY",
  style: {
    colorPrimary: "#ed7e31"
  }
};
export {
  a as default
};
